import { Reveal, CTAButton } from "@/components/okaia/Reveal";

export const Orientation = () => (
  <section id="orientation" data-testid="section-orientation" className="bg-[#F9F8F6] py-16 md:py-24">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="border border-[#C8A97E]/50 p-8 md:p-14 lg:p-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="okaia-overline mb-6 text-[#B39265]">Orientation formation — questionnaire gratuit</p>
              <h2 className="font-serif-display text-4xl leading-[1.1] tracking-tight text-[#0B2215] md:text-5xl">
                Vous cherchez une formation adaptée à votre projet&nbsp;?
              </h2>
              <p className="mt-6 max-w-xl text-sm font-light italic text-[#4A5A52]">
                Ce questionnaire est gratuit et distinct du Diagnostic Business à 49&nbsp;€. Il ne
                vous oblige pas à acheter un diagnostic ni une formation.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.15}>
              <div className="space-y-5 text-base font-light leading-relaxed text-[#4A5A52]">
                <p>
                  Décrivez votre situation, votre objectif et les compétences que vous souhaitez
                  développer. Vos réponses nous permettent d'étudier votre demande et de vous
                  orienter vers des pistes de formation adaptées.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.25}>
              <div className="mt-8">
                <CTAButton label="Remplir le questionnaire gratuit d'orientation formation" testId="orientation-cta" />
                <p className="mt-4 text-xs font-light italic text-[#4A5A52]">
                  Quelques minutes suffisent pour nous aider à mieux comprendre votre besoin.
                </p>
                <p className="mt-6 border-t border-[#0B2215]/10 pt-4 text-xs font-light text-[#4A5A52]">
                  Une question sur le questionnaire gratuit d'orientation formation&nbsp;? Écrivez-nous à{" "}
                  <a
                    href="mailto:orientation@okaiadev.fr"
                    data-testid="orientation-email-link"
                    className="font-medium text-[#0B2215] underline decoration-[#0B2215]/70 underline-offset-2 transition-colors duration-300 hover:text-[#0B2215] hover:decoration-[#C8A97E]"
                  >
                    orientation@okaiadev.fr
                  </a>
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  </section>
);
